export default function canBeDisplayed(mimeType) {
  const allowedMimeTypes = ['image/png', 'image/jpeg', 'image/gif', 'image/bmp', 'image/webp']
  if (typeof mimeType === 'string') {
    for (let i = 0; i < allowedMimeTypes.length; i++) {
      const allowedMimeType = allowedMimeTypes[i];
      if (mimeType.includes(allowedMimeType)) {
        return true;
      }
    }
  }
  return false;
}
